import EditableText from '../../../components/cms/EditableText';

export default function FAQSection() {
  return (
    <section id="faq" className="bg-white py-24">
      <div className="max-w-5xl mx-auto px-6">
        <div className="mb-10">
          <p className="text-xs font-bold uppercase tracking-widest text-[#8B9D83] mb-3">FAQ</p>
          <EditableText
            section="seo"
            field="homeFaqTitle"
            tag="h2"
            className="font-serif text-4xl md:text-5xl font-semibold text-[#1A1A1A]"
          />
        </div>

        <div className="flex flex-col gap-4">
          {[1, 2, 3, 4].map((id) => (
            <details key={id} className="group border border-stone-200 rounded-2xl p-5">
              <summary className="list-none cursor-pointer flex items-center justify-between gap-4">
                <EditableText
                  section="seo"
                  field={`homeFaqQ${id}`}
                  tag="span"
                  className="font-semibold text-[#1A1A1A]"
                />
                <span className="text-[#8B9D83] text-xl leading-none">+</span>
              </summary>
              <EditableText
                section="seo"
                field={`homeFaqA${id}`}
                tag="p"
                multiline
                className="text-[#6B6B6B] text-sm leading-relaxed mt-3"
              />
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
